import React from 'react';
import classNames from 'classnames';
import { withStyles } from './../../../../themes/default';

const styles = theme => ({
  root: {
    display: 'flex',
    '& > *': {
      '&:not(:last-child)': {
        marginRight: theme.spacing.unit
      }
    }
  },
  left: { justifyContent: 'flex-start' },
  center: { justifyContent: 'center' },
  right: { justifyContent: 'flex-end' }
});

const Buttons = ({children, classes, align, ...rest}) => {

  const _align = align ? classes[align] : null;

  return (
    <div className={ classNames(_align, classes.root) }>
      { children }
    </div>
  )

}

export default withStyles(styles)(Buttons);
